export enum LeadPropertyFeature {
  BALCONE_TERRAZZO = 'BALCONE_TERRAZZO',
  BOX_AUTO = 'BOX_AUTO',
  GIARDINO = 'GIARDINO',
  ASCENSORE = 'ASCENSORE',
}
